'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductCardSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'animate-pulse',
        'ea-product-card-skeleton',
        'col-span-1 h-[400px] w-full bg-neutral-100',
        className,
      )}
    >
    </div>
  );
}
